import store from '../'

let resource = store.defineResource({
  name: "annotations",
  relations: {
    belongsTo: {
      userAssignments: {
        parent: true,
        localKey: "userAssignmentId",
        localField: "userAssignment"
      },
      annotationColors: {
        localKey: "colorId",
        localField: "color"
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/annotations.js